<template>
	<div style="background-color: #669188; color:white; box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;">
		<header>
			<nav class="navbar navbar-expand-md container">
				<div class="container-fluid ">
					<a @click="dataLink" class="d-flex align-items-center mb-md-0 me-md-auto text-decoration-none">
						<span class="fs-4"><img src="../assets/logo_toa.png" alt="" width="160"></span>
					</a>
					<button class="navbar-toggler" style="color:#f9b6ad; background-color: #f9b6ad;" type="button"
						data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
						aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
						<span class="navbar-toggler-icon" style="color:#f9b6ad; background-color: #f9b6ad;"></span>
					</button>
					<div class="collapse navbar-collapse " id="navbarSupportedContent">
						<ul class="navbar-nav ms-auto cusor-pointer">
							<li v-if="(!token.data)" class="nav-item mx-2">
								<!-- <router-link :to="{ name: 'home' }" class="nav-link">หน้าหลัก</router-link> -->
								<a class="nav-link" aria-current="page" @click="dataLink"
									style="color:white">หน้าหลัก</a>
							</li>
							<!-- <li class="nav-item mx-2">
								<a class="nav-link" href="https://www.toagroup.com">เว็บทีโอเอ</a>
							</li> -->
							<!-- <li class="nav-item mx-2">
								<a class="nav-link" href="#">ค้นหา SO</a>
							</li> -->
							<li v-if="(!token.data)" class="nav-item mx-2 "
								style="background: #f9b6ad; border-radius: 6px;">
								<router-link :to="{ name: 'login' }" class="nav-link">Login</router-link>
							</li>
							<li v-if="(toaomt_role_user.data)" class="nav-item mx-2 "
								style="background: #f9b6ad;  border-radius: 6px;">
								<a class="nav-link" @click="dataLink" style="color: white;">ข้อมูล</a>
							</li>
							<li v-if="(toaomt_admin.data)" class="nav-item mx-2 "
								style="background: #f9b6ad;  border-radius: 6px;">
								<a class="nav-link" @click="dataLink" style="color: white;">ข้อมูล</a>
							</li>
							<li v-if="(token.data)" class="nav-item mx-2 "
								style="background: #003e92;  border-radius: 6px;">
								<a class="nav-link" @click="logout" style="color: white;">Logout</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</header>
	</div>
</template>

<script>
import { inject, reactive, onMounted, onBeforeUpdate } from 'vue';
import { useRouter, useRoute } from 'vue-router';
export default {
	setup() {
		const CryptoJS = inject('cryptojs')
		const router = useRouter();
		const route = useRoute()
		// const route_name = route.name;
		// console.log(route);

		// var token = localStorage.toaomt_token
		// var toaomt_role_user = localStorage.toaomt_role_user
		// var toaomt_admin = localStorage.toaomt_admin

		const token = reactive({
			data: ""
		})
		const toaomt_role_user = reactive({
			data: ""
		})
		const toaomt_admin = reactive({
			data: ""
		})

		onMounted(() => {

			token.data = localStorage.getItem('toaomt_token')
			toaomt_role_user.data = localStorage.getItem('toaomt_role_user')
			toaomt_admin.data = localStorage.getItem('toaomt_admin')
			// console.log('Component mounted!')
		});

		onBeforeUpdate(() => {
			//   console.log('Component updated!')
		})


		const destroy = () => {
			// localStorage.removeItem('toaomt_token');
			// localStorage.removeItem('toaomt_role_user');
			// localStorage.removeItem('toaomt_admin');
			window.location.href = '/';
		}

		const logout = () => {
			if (confirm('คุณต้องการออกจากระบบใช่หรือไม่?')) {
				localStorage.removeItem('toaomt_token');
				localStorage.removeItem('toaomt_role_user');
				localStorage.removeItem('toaomt_admin');
				window.location.href = '/';
			}
		}

		// console.log(route_name.value);

		const dataLink = () => {
			// const token_role_user = localStorage.toaomt_role_user;
			// console.log(toaomt_role_user.data);
			if (token.data) {
				if (toaomt_role_user.data) {
					const token_role_user_result = CryptoJS.AES.decrypt(toaomt_role_user.data, process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString(CryptoJS.enc.Utf8);
					if (token_role_user_result == process.env.VUE_APP_IS_SALE) {
						router.push({
							name: "mycustomer",
						})
					}
					if (token_role_user_result == process.env.VUE_APP_IS_STORE) {
						router.push({
							name: "mystore",
						})
					}
				} else {
					router.push({
						name: "admin",
					})
				}
			} else {
				router.push({
						name: "home",
					})
			}


		}

		const img = '../assets/' + process.env.VUE_APP_MAIN_BACKGROUND

		if (toaomt_admin.data) {
			const temp_check_admin = CryptoJS.AES.decrypt(toaomt_admin.data, process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString(CryptoJS.enc.Utf8);
			if (temp_check_admin != process.env.VUE_APP_IS_ADMIN) {
				logout();
			}
		}
		return {
			img,
			logout,
			token,
			toaomt_role_user,
			dataLink,
			toaomt_admin,
			destroy
		}
	},
	data() {
		return {
			render: false
		}
	},
}
</script>

<style lang="scss" scoped>
.navbar-toggler-icon {
	background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

a:link {
	color: white;
}

/* visited link */
a:visited {
	color: white;
}

/* mouse over link */
a:hover {
	color: white;
}

/* selected link */
a:active {
	color: white;
}
</style>